// openPostDraft.js
'use strict';
import { v4 } from 'uuid';

import {
  POST_IMAGE_DIAMOND_DEFAULT,
  POST_DIAMOND_DEFAULT,
  BROADCAST_MESSAGE_VIDEO_DIAMOND_MIN,
} from '../RemoteConfigKeys.js';

import setPostDraftData from '../action/setPostDraftData.js';
import addModal from '../action/addModal.js';
import processPostDraftFiles from '../action/processPostDraftFiles.js';

import getOperationData from '../selector/getOperationData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import { getPostDiamondData } from '../selector/getRemoteConfigComputedData.js';

import { PostDraftField, UploadJobType } from '../resource/uploadConstants.js';
import getVideoDuration from '../resource/getVideoDuration.js';

const MODAL_ID = 'PostDraft';

/**
 * Open post draft
 * @kind action
 * @param {AssetPurpose} {purpose} - assets purpose.
 * @param {array} {files} - files.
 * @param {UploadJobType} {uploadJobType} - upload job type.
 * @return {Promise} Action promise.
 */
const openPostDraft =
  ({ purpose, files = [], uploadJobType } = {}) =>
  async (dispatch, getState) => {
    dispatch(
      setPostDraftData({
        key: PostDraftField.UPLOAD_JOB_ID,
        payload: {
          value: v4(),
        },
      })
    );
    await dispatch(
      processPostDraftFiles({
        purpose,
        files,
      })
    );
    const isValid = getOperationData(
      getState(),
      ['postDraft', purpose],
      'isValid'
    );
    if (!isValid) {
      return dispatch({ type: '' });
    }
    let priceIndex = 0;
    const isPost = UploadJobType.POST === uploadJobType;
    const isImage = files[0]?.type?.startsWith('image/');
    const isVideo = files[0]?.type?.startsWith('video/');
    if (isPost) {
      if (isVideo) {
        const postVideoDurationCheckpoints = getPostDiamondData(
          getState(),
          'postVideoDurationCheckpoints'
        );
        const videoDuration = await getVideoDuration({ file: files[0] });
        priceIndex = Math.min(
          postVideoDurationCheckpoints.findIndex(
            duration => videoDuration >= duration
          ),
          postVideoDurationCheckpoints.length
            ? postVideoDurationCheckpoints.length - 1
            : 0
        );
      }
    }
    dispatch(
      setPostDraftData({
        key: PostDraftField.UNLOCK_PRICE,
        payload: {
          value:
            UploadJobType.STORY === uploadJobType && isVideo
              ? getRemoteConfigData(
                  getState(),
                  BROADCAST_MESSAGE_VIDEO_DIAMOND_MIN
                )
              : isImage
                ? getRemoteConfigData(getState(), POST_IMAGE_DIAMOND_DEFAULT)
                : getPostDiamondData(getState(), POST_DIAMOND_DEFAULT)[
                    priceIndex
                  ],
        },
      })
    );
    return dispatch(
      addModal({
        id: MODAL_ID,
        prevId: 'UploadMenuModal',
        isHigherThanAll: true,
        transitionStatus: 'opening',
      })
    );
  };

export default openPostDraft;
